import { proxy } from 'valtio';
import { proxySet } from 'valtio/utils';

import { type Action } from '@canvas/model/permissions';

import { type PermissionsState } from './permissions';

/**
 * Represents the permissions the current user has at the container and board level.
 *
 * @description Board: The 'object' in the Atlassian Collaboration model.
 * @description Container: The entity which houses the object (board) in the
 * Atlassian Collaboration model.
 * @remarks See go/collab-model for more on the Collaboration model.
 */
export const currentPermissions = proxy<PermissionsState>({
  boardAccess: proxySet([]),
  boardAccessDisableOverride: proxySet([]),
  id: undefined,
});

export const resetPermissionState = () => {
  currentPermissions.boardAccess.clear();
  currentPermissions.boardAccessDisableOverride.clear();
  currentPermissions.id = undefined;
};

/**
 * Returns the current board access, taking into account any temporary overrides.
 */
export const getEffectiveBoardAccess = (
  boardAccess = currentPermissions.boardAccess,
  boardAccessDisableOverride = currentPermissions.boardAccessDisableOverride,
  result: Set<Action> = new Set()
) => {
  result.clear();
  for (const action of boardAccess) {
    if (!boardAccessDisableOverride.has(action)) {
      result.add(action);
    }
  }

  return result;
};
